import {
  CodeOutlined,
  ControlOutlined,
  GlobalOutlined,
  LockOutlined,
  TagOutlined,
} from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { useAppSelector } from '@store/hooks'
import { selectSelectedProgram } from '@store/membership/ProgramReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Col, Row } from 'antd'

const InformationsTab = () => {
  const program = useAppSelector(selectSelectedProgram())

  if (!program) {
    return <></>
  }

  return (
    <Page>
      <Row gutter={[32, 32]}>
        <Col span={12}>
          <FormCard
            title="Program name"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['programName']}
            icon={<ControlOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Program visibility"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['protection']}
            icon={<LockOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Loyalty tier"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['loyaltyTier']}
            icon={<TagOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Google Tag Manager"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['gtm']}
            icon={<CodeOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="SEO"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['seo']}
            icon={<GlobalOutlined />}
          />
        </Col>
      </Row>
    </Page>
  )
}

export default InformationsTab
